<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-input v-model="filterData.name" placeholder="物业名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="showSearch">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="showRenew">急需续费</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="showExpired">已到期</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="primary" @click="formVisible = true">添加物业</el-button>
        </el-col>
      </el-row>
      <el-table :data="records" border default-expand-all>
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="btns">
              <el-button icon="el-icon-user">用户数 ({{ props.row.members_count }})</el-button>
              <el-button icon="el-icon-money">订单金额 (￥{{ props.row.orders_total }})</el-button>
              <el-button icon="el-icon-coordinate">入驻商家 ({{ props.row.stores_count }})</el-button>
              <el-button icon="el-icon-goods">上传商品 ({{ props.row.products_count }})</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物业名称" prop="name" width="100px"></el-table-column>
        <el-table-column label="后台地址" prop="domain" width="300px">
          <template slot-scope="scope">
            <el-link type="primary" :href="`http://${scope.row.id}.${$env.domain}/manage`" target="_blank">http://{{ scope.row.id }}.{{ $env.domain }}/manage</el-link>
          </template>
        </el-table-column>
        <el-table-column label="开通日期" prop="started_at" width="120"></el-table-column>
        <el-table-column label="到期日期" prop="expired_at" width="120"></el-table-column>
        <el-table-column label="状态" prop="status">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">使用中</el-tag>
            <el-tag v-else-if="scope.row.status == 0">待开通</el-tag>
            <el-tag type="info" v-else>已停用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.started_at" @click="onSetting(scope.row)">配置</el-button>
            <el-button type="text" v-if="scope.row.started_at" @click="onRenew(scope.row.id)">续费</el-button>
            <el-button type="text" @click="onEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="onDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-dialog
      title="物业信息"
      :visible.sync="formVisible"
      width="600px">
      <el-form ref="formRef" :model="formData" :rules="ruleValidate" label-width="160px">
        <el-form-item label="物业名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="物业域名前缀(唯一)" prop="id">
          <el-input v-model="formData.id"></el-input>
        </el-form-item>
        <el-form-item label="物业LOGO" prop="logo">
          <el-upload
            class="img-uploader"
            name="thumb"
            action=""
            :show-file-list="false"
            :on-success="onImgSuccess"
            :on-remove="onImgRemove"
            :before-upload="beforeimgUpload"
            :http-request="onUpload"
            accept=".jpg,.jpeg,.png,.gif"
          >
            <img v-if="formData.logo" :src="host + formData.logo" class="img">
            <i v-else class="el-icon-picture-outline img-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="formData.contact"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="formData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="启用日期" prop="started_at">
          <el-date-picker v-model="formData.started_at" type="date" value-format="yyyy-MM-DD" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="使用年限" prop="years">
          <el-input v-model.number="formData.years"></el-input>
        </el-form-item>
        <el-form-item label="微信支付证书V3">
          <el-input v-model="formData.certs"></el-input>
        </el-form-item>
        <el-form-item label="微信支付密钥">
          <el-input v-model="formData.key"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="settingVisible"
      :title="`${currentRow.name}模块配置`"
      :visible.sync="settingVisible"
      width="600px">
      <el-form ref="formRef" :model="formData" :rules="ruleValidate" label-width="160px">
        <el-form-item label="配置模块" class="permission-tree">
          <el-checkbox-group v-model="sectionIds">
            <el-checkbox v-for="section in sections" :key="section.id" :label="section.id" :disabled="section.type == '基础模块'">{{ section.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancelSetting">取 消</el-button>
        <el-button type="primary" @click="onSaveSetting">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import request from '@/utils/request'
import upload from '@/utils/upload'
export default {
  name: 'Dashboard',
  data () {
    return {
      filterData: {
        name: '',
        renew: 0,
        expired: 0,
      },
      host: process.env.VUE_APP_BASE_HOST,
      isEdit: false,
      formData: {
        name: '',
        id: '',
        contact: '',
        mobile: '',
        address: '',
        years: 1
      },
      ruleValidate: {
        name: [{ required: true, message: '请输入物业名称', trigger: 'blur' }],
        id: [{ required: true, message: '请输入物业域名前缀（英文字母）', trigger: 'blur' }],
        contact: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        started_at: [{ required: true, message: '请选择启用日期', trigger: 'blur' }],
        years: [
          { required: true, message: '请输入年限', trigger: 'blur' },
          { type: 'number', message: '必须为数字', trigger: 'blur' }
        ],
      },
      records: [],
      currentRow: null,
      formVisible: false,
      settingVisible: false,
      sections: [],
      sectionIds: []
    }
  },
  mounted () {
    this.getList()
    this.getSections()
  },
  methods: {
    getList () {
      request.get('tenants', this.filterData).then(res => {
        this.records = res.data
      })
    },
    showSearch()
    {
      this.filterData.renew = 0
      this.filterData.expired = 0
      this.getList()
    },
    showRenew() {
      this.filterData.renew = 1
      this.filterData.expired = 0
      this.getList()
    },
    showExpired() {
      this.filterData.renew = 0
      this.filterData.expired = 1
      this.getList()
    },
    getSections()
    {
      request.get('sections').then(res=>{
        this.sectionIds = []
        this.sections = res.data
        res.data.forEach(item=>{
          if(item.type == '基础模块') {
            this.sectionIds.push(item.id)
          }
        })
      })
    },
    onSetting(row) {
      this.currentRow = row
      this.settingVisible = true
    },
    onRenew (row) {
      this.currentRow = row
      this.$prompt('请输入续费年限', '续费提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '已续费' + value + '年'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消续费'
        })
      })
    },
    onEdit (row) {
      this.isEdit = true
      this.formData = row
      this.formVisible = true
    },
    cancel() {
      this.isEdit = false
      this.formVisible = false
      this.formData = {
        name: '',
        id: '',
        logo: '',
        contact: '',
        mobile: '',
        address: '',
        years: 1
      }
    },
    save() {
      this.$refs.formRef.validate((valid) => {
        const originData = {
          name: '',
          id: '',
          logo: '',
          contact: '',
          mobile: '',
          address: '',
          years: 1
        }
        if (valid) {
            const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          if (this.isEdit) {
            request.put('tenants/' + this.formData.id, this.formData).then(()=>{
              this.getList()
              this.formVisible = false
              this.formData = originData
              loading.close()
            }).catch(()=>{
              loading.close()
            })

          } else {
            request.post('tenants', this.formData).then(()=>{
              this.getList()
              this.formVisible = false
              this.formData = originData
              loading.close()
            }).catch(()=>{
              loading.close()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onDel(id) {
      this.$confirm('确定删除此项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete(`tenants/${id}`).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getList()
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onImgSuccess () {
      //
    },
    onImgRemove () {
      //
    },
    beforeimgUpload (file) {
      const isIMG = ['image/jpeg', 'image/png'].includes(file.type);
      const isLt200K = file.size / 1024 / 1024 / 1024 < 200;

      if (!isIMG) {
        this.$message.error('上传图片只能是 JPG,PNG 格式!');
      }
      if (!isLt200K) {
        this.$message.error('上传图片大小不能超过 200KB!');
      }
      return isIMG && isLt200K;
    },
    onUpload (obj) {
      const upData = new FormData();
      upData.append('logo', obj.file);
      upload.post('tenants/logo', upData).then(res => {
        this.formData.logo = res
        // console.log(this.formData)
        this.$forceUpdate()
      })
    },
    onCancelSetting() {
      this.settingVisible = false
    },
    onSaveSetting() {
      this.settingVisible = false
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
.img-uploader-icon {
  font-size: 18px;
  color: #8c939d;
  width: 100px;
  height: 50px;
  line-height: 64px;
  text-align: center;
}
.img {
  width: 100px;
  height: 50px;
  display: block;
}
.btns {
  margin: 0 20px;
  text-align: right;
}
</style>
